import { Settings } from "../helpers/settings";
import { SecondaryScreenLayout } from "../interfaces/secondaryScreens";

const DefaultPlayersColumns = 4;
const DefaultPlayersRows = 3;

const DefaultLayout: SecondaryScreenLayout = {
  id: undefined,
  videoContainers: [
    { id: "default", capacity: DefaultPlayersColumns * DefaultPlayersRows },
  ],
  variants: [
    {
      justifyContent: "center",
      topBar: {
        brand: true,
        user: true,
        watchers: true,
      },
      columns: [
        {
          playerColumns: 3,
          playerRows: 3,
          videoContainerId: "default",
          style: { width: "75%" },
          contentType: "players",
        },
        {
          style: { width: "25%" },
          contentType: "chat",
        },
      ],
    }
  ],
};

export const ScreenConstants = {
  DefaultPlayersColumns,
  DefaultPlayersRows,
  DefaultLayout,
};